import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import WorkerProfile from './pages/WorkerProfile';
import BrowseWorkers from './pages/BrowseWorkers';
import WorkerDetail from './pages/WorkerDetail';
import JobRequests from './pages/JobRequests';
import Calendar from './pages/Calendar';
import ContractorProfile from './pages/ContractorProfile';
import Messages from './pages/Messages';
import Chat from './pages/Chat';
import JobHistory from './pages/JobHistory';
import Availability from './pages/Availability';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

// Protected route — redirects to login if not authenticated
function ProtectedRoute({ user, authLoading, children }) {
  if (authLoading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        backgroundColor: '#f0f2f5',
      }}>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{ color: '#E94560', fontSize: '28px', marginBottom: '12px' }}>TradePower</h2>
          <p style={{ color: '#666', fontSize: '14px' }}>Loading...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setAuthLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />

          {/* Protected routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/worker-profile" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <WorkerProfile />
            </ProtectedRoute>
          } />
          <Route path="/browse" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <BrowseWorkers />
            </ProtectedRoute>
          } />
          <Route path="/worker/:workerId" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <WorkerDetail />
            </ProtectedRoute>
          } />
          <Route path="/job-requests" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <JobRequests />
            </ProtectedRoute>
          } />
          <Route path="/calendar" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <Calendar />
            </ProtectedRoute>
          } />
          <Route path="/contractor-profile" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <ContractorProfile />
            </ProtectedRoute>
          } />
          <Route path="/messages" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <Messages />
            </ProtectedRoute>
          } />
          <Route path="/chat/:jobRequestId" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <Chat />
            </ProtectedRoute>
          } />
          <Route path="/job-history" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <JobHistory />
            </ProtectedRoute>
          } />
          <Route path="/availability" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <Availability />
            </ProtectedRoute>
          } />
          <Route path="/tp-admin" element={
            <ProtectedRoute user={user} authLoading={authLoading}>
              <AdminDashboard />
            </ProtectedRoute>
          } />

          {/* Catch all — redirect to login */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;